"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginLogListApi = loginLogListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function loginLogListApi(params) {
  return (0, _request.default)({
    url: '/admin/loginlog/list',
    method: 'get',
    params: params
  });
}